import React from 'react';
import Image from 'next/image';

interface InclusionExclusionGridProps {
  items: string[];
  type: 'included' | 'excluded';
  heading: string;
}

const icon = {
  included: (
    <Image
      src="/tick.svg"
      alt="Included"
      width={24}
      height={24}
      className="w-[20px] h-[20px] md:w-[24px] md:h-[24px]"
    />
  ),
  excluded: (
    <Image
      src="/cross.svg"
      alt="Excluded"
      width={20}
      height={20}
      className="w-[16px] h-[16px] md:w-[20px] md:h-[20px]"
    />
  )
};

const InclusionExclusionGrid: React.FC<InclusionExclusionGridProps> = ({
  items,
  type,
  heading
}) => (
  <div className="mb-6">
    <h2 className="text-[22px] md:text-[24px] lg:text-[26px] font-bold mb-3">
      {heading}
    </h2>
    <div className="text-[#677083] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-3">
      {items.map((item, idx) => (
        <div
          key={idx}
          className="flex w-[100%] items-center bg-[#F8F9FB] rounded-lg px-4 py-3 font-medium text-[14px] md:text-base"
        >
          <div className="w-[10%]">{icon[type]}</div>
          <span className="w-[90%]">{item}</span>
        </div>
      ))}
    </div>
  </div>
);

export default InclusionExclusionGrid;
